<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" class="text-center">
          <div class="clearfix">
            <h1 class="display-3">Please wait</h1>
            <div class="clearfix"></div>
            <div style="margin: 0 auto; width: 10px;">
              <div class="loader-dark-blue medium mb-5 mt-5"></div>
            </div>
            <h4>You'll be redirected shortly.</h4>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import config from '@/constant'
import { auth, server } from '@/services/'

export default {
  name: 'redirect',
  created () {
    let hash = this.$route.query.hash;
    auth.setToken(hash);
    server.get('/getLoginUserInfo').then(
      resp => {
        let user = resp.data.msgContent.data[0]
        auth.setUser(user)
        this.$store.commit('userProfile/setUser', user)
        this.$router.push({name: 'Dashboard'})
      }
    )

  }
}
</script>
